/**
 * 查询码api
 * date:2022 10 24
 */
 import httpRequest from '@/utils/request.js';

 /**获取传感器分页列表 */
export const getSensorList = (params = {}) => httpRequest.httpGet({
    url: '/service/find/sensor/page', params: {
      ...params
    }
  });
 /**生成查询码
 */
export const getCodeGenerate = (data = {}) => httpRequest.httpPost( '/service/find/code/generate',data);